import { Page } from "src/components/Interfaces";
import { appSettings } from "src/config";

export const getPageContentByType = (pagesData: Page[], pageType: string) => {
    const page = pagesData?.find((p) => p.attributes.PageName === pageType);

    // if (page) return page.attributes.Content.replaceAll('(/uploads/', `(${appSettings.cmsUrl}/uploads/`);
    if (page) return page.attributes.Content;
    return "";
  }